import { render } from "./LoadingLayout.vue?vue&type=template&id=3d780cfe&scoped=true"
const script = {}

import "./LoadingLayout.vue?vue&type=style&index=0&id=3d780cfe&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d780cfe"]])

export default __exports__